import React from 'react';
import { Button, linkedinUrl, githubUrl, emailUrl } from './Imports';

function Footer() {
    return (
        <div className="footer">
            <div className='line' />
            <div className="content">
                <h2>Have Something in Mind ?</h2>
                <h3><i>Drop me a line. I will get back to you.</i></h3>
                <div className="links">
                    <Button className='button' variant="contained" href={emailUrl}>
                        Email Me
                    </Button>
                    {/* <Button className='button' variant="contained" href="#">
                        Whatsapp
                    </Button> */}
                </div>
            </div>
            <div className='line' />
            <div className="footerBTM">
                <h5>2024 All Rights Reserved</h5>
                {/* Combine LinkedIn and GitHub links */}
                <h5 className='links'>
                    <a href={linkedinUrl} target="_blank" rel="noopener noreferrer"><i>LinkedIn</i></a> | 
                    <a href={githubUrl} target="_blank" rel="noopener noreferrer"><i>GitHub</i></a>
                </h5>
            </div>
        </div>
    );
}

export default Footer;
